/**
 * Helpers for reading secret material from the URL fragment (hash).
 *
 * The browser never transmits the fragment to the server, so it is the correct
 * place to carry zero-knowledge secrets (e.g. a Trustee_Secret). Query-string
 * params, by contrast, are sent to the server and can leak into access logs,
 * proxies, and referrer headers.
 */

/** Parse `window.location.hash` into a key/value map (leading `#` stripped). */
export function parseHashParams(): Record<string, string> {
  if (typeof window === "undefined") return {};
  const raw = window.location.hash.replace(/^#/, "");
  if (!raw) return {};
  const params = new URLSearchParams(raw);
  const out: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    out[key] = value;
  }
  return out;
}

/**
 * Remove the fragment from the address bar / history without reloading, so
 * secret material captured on mount does not linger in the URL.
 */
export function scrubHash(): void {
  if (typeof window === "undefined") return;
  history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search
  );
}
